import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MyWoStateService {
  formData: any;
  tabledata: any[] | undefined;
  constructor() {}
}
